/*
  Alyaka — banner stats for the Banner Manager app (job/banner-stats, 2026-10-01).
  Counts how often each managed banner is SEEN (at least half on screen and really visible — active slide,
  not hidden — for about a second; once per page view) and CLICKED (a link inside the banner), and sends
  only the banner keys to the app. No cookies, no customer data. GA4 promotion events stay in aly-ga4-extras.

  Keys:  hero:<handle>  card:<handle>  grid:<handle>  menu:<handle>  side:<collection id>
  Runs on the published theme only; add ?aly_stats=debug to a page to dry-run (console log, nothing stored).
*/
(function () {
  var me = document.currentScript;
  var endpoint = me && me.getAttribute('data-endpoint');
  var shop = me && me.getAttribute('data-shop');
  if (!endpoint || !shop) return;
  var debug = /[?&]aly_stats=debug\b/.test(location.search);
  var S = window.Shopify || {};
  if (!debug) {
    if (S.designMode || (S.theme && S.theme.role && S.theme.role !== 'main')) return;
    if (navigator.webdriver || /bot|crawl|spider|slurp|lighthouse|headless|facebookexternalhit|pingdom|gtmetrix/i.test(navigator.userAgent)) return;
  }
  if (!('IntersectionObserver' in window) || !window.JSON) return;

  var SEL = '[data-aly-hero],[data-aly-card],[data-aly-grid-banner],[data-aly-menu-tile],[data-aly-side]';
  var ATTR = [['data-aly-hero', 'hero:'], ['data-aly-card', 'card:'], ['data-aly-grid-banner', 'grid:'], ['data-aly-menu-tile', 'menu:'], ['data-aly-side', 'side:']];
  var seen = {}, clicked = {}, outV = [], outC = [], ticks = new Map(), onScreen = new Set(), observed = new WeakSet();
  var timer = null, flushTimer = null;

  function keyOf(el) {
    for (var i = 0; i < ATTR.length; i++) {
      var v = el.getAttribute(ATTR[i][0]);
      if (v) return ATTR[i][1] + v;
    }
    return null;
  }
  function visible(el) {
    if (el.classList.contains('swiper-slide') && !el.classList.contains('swiper-slide-active')) return false;
    if (el.checkVisibility) return el.checkVisibility({ opacityProperty: true, visibilityProperty: true });
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    }
    return true;
  }

  function send() {
    if (!outV.length && !outC.length) return;
    var body = JSON.stringify({ s: shop, v: outV.splice(0), c: outC.splice(0), d: debug ? 1 : undefined });
    if (debug) {
      console.log('[aly-stats] send', body);
      fetch(endpoint, { method: 'POST', body: body, headers: { 'Content-Type': 'text/plain' } })
        .then(function (r) { return r.text().then(function (t) { console.log('[aly-stats] reply', r.status, t); }); })
        .catch(function (e) { console.log('[aly-stats] failed', e); });
      return;
    }
    var blob = new Blob([body], { type: 'text/plain' });
    if (!(navigator.sendBeacon && navigator.sendBeacon(endpoint, blob))) {
      fetch(endpoint, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    }
  }
  function later() {
    if (!flushTimer) flushTimer = setTimeout(function () { flushTimer = null; send(); }, 15000);
  }

  /* a banner must stay visible over two checks (~1.2 s) */
  function tick() {
    if (document.visibilityState !== 'visible') return;
    onScreen.forEach(function (el) {
      var k = keyOf(el);
      if (!k || seen[k]) { onScreen.delete(el); return; }
      if (!visible(el)) { ticks.set(el, 0); return; }
      var n = (ticks.get(el) || 0) + 1;
      ticks.set(el, n);
      if (n >= 2) {
        seen[k] = 1;
        outV.push(k);
        onScreen.delete(el);
        if (debug) console.log('[aly-stats] seen', k);
        later();
      }
    });
    if (!onScreen.size && timer) { clearInterval(timer); timer = null; }
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting && en.intersectionRatio >= 0.5) onScreen.add(en.target);
      else { onScreen.delete(en.target); ticks.delete(en.target); }
    });
    if (onScreen.size && !timer) timer = setInterval(tick, 600);
  }, { threshold: [0, 0.5] });

  function scan() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (observed.has(el)) return;
      observed.add(el);
      var k = keyOf(el);
      if (k && !seen[k]) io.observe(el);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t || !t.closest('a[href]')) return;
    var el = t.closest(SEL);
    var k = el && keyOf(el);
    if (!k || clicked[k]) return;
    clicked[k] = 1;
    outC.push(k);
    if (!seen[k]) { seen[k] = 1; outV.push(k); }
    if (debug) console.log('[aly-stats] click', k);
    send();
  }, true);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') send(); });
  window.addEventListener('pagehide', function () { send(); });

  function start() {
    scan();
    var main = document.getElementById('MainContent');
    var pending = null;
    if (main && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (!pending) pending = setTimeout(function () { pending = null; scan(); }, 400);
      }).observe(main, { childList: true, subtree: true });
    }
    if (debug) console.log('[aly-stats] watching', document.querySelectorAll(SEL).length, 'banners');
  }
  if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 3000 });
  else setTimeout(start, 1500);
})();
